import { Routes } from '@angular/router';
import { ResearchComponent } from './pages/research/research.component';
import { AuthGuard } from './auth/guards/auth.guard';
import { ConsultancyComponent } from './pages/consultancy/consultancy.component';
import { TestDevComponent } from './pages/test-dev/test-dev.component';
import { PasswordResetRedirectGuard } from './guards/password-reset-redirect.guard';
import { consultancyResolver } from './resolvers/consultancy.resolver';
import { esupervisorResolver } from './resolvers/esupervisor.resolver';
import { collaborationResolver } from './resolvers/collaboration.resolver';
import { consultanciesResolver } from './resolvers/consultancies.resolver';
import { academicResolver } from './resolvers/academic.resolver';

export const routes: Routes = [
  { path: 'home', redirectTo: '/', pathMatch: 'full' },
  { path: 'consultancy', redirectTo: '/esupervisor', pathMatch: 'full' },
  {
    path: '',
    loadComponent: () => import('./layout/main-layout/main-layout.component').then(m => m.MainLayoutComponent),
    children: [
      {
        path: '', loadComponent: () => import('./pages/home/home.component').then(m => m.HomeComponent), title: 'Research Decode | Freelance Research Collaboration Platform', resolve: {
          consultancies: consultanciesResolver
        }
      },
      { path: 'requests', component: ResearchComponent, title: 'Research Requests | Research Decode' },
      // { path: 'esupervisor', component: ConsultancyComponent, title: 'Consultancy | Research Decode' },
      { path: 'consultancies', component: ConsultancyComponent, title: 'Consultancies | Research Decode' },
      { path: 'collaborations', loadComponent: () => import('./pages/collaborations/collaborations.component').then(m => m.CollaborationsComponent), title: 'Collaborations | Research Decode' },
      // { 
      //   path: 'collaboration-detail/:id', 
      //   loadComponent: () => import('./pages/collaboration-detail/collaboration-detail.component').then(m => m.CollaborationDetailComponent) 
      // },
      {
        path: 'collaborations/:slug',
        loadComponent: () => import('./pages/collaboration-detail/collaboration-detail.component').then(m => m.CollaborationDetailComponent),
        resolve: {
          collaboration: collaborationResolver
        }
      },
      // { 
      //   path: 'consultancy-detail/:teacherId', 
      //   loadComponent: () => import('./pages/esupervisor-detail/esupervisor-detail.component').then(m => m.EsupervisorDetailComponent) 
      // },
      // { 
      //   path: 'consultancy-detail/:teacherId/:consultancyId', 
      //   loadComponent: () => import('./pages/consultancy-detail/consultancy-detail.component').then(m => m.ConsultancyDetailComponent) 
      // },
      {
        path: 'consultancies/:slug',
        loadComponent: () => import('./pages/consultancy-detail/consultancy-detail.component').then(m => m.ConsultancyDetailComponent),
        resolve: {
          consultancy: consultancyResolver
        }
      },
      {
        path: 'events',
        loadComponent: () => import('./pages/events-page/events-page.component').then(m => m.EventsPageComponent),
        title: 'Events | Research Decode'
      },
      {
        path: 'e-academia',
        loadComponent: () => import('./pages/academic/academic.component').then(m => m.AcademicComponent),
        title: 'Academic Opportunities | Research Decode'
      },
      {
        path: 'e-academia/:slug',
        loadComponent: () => import('./pages/academic-detail/academic-detail.component').then(m => m.AcademicDetailComponent),
        // title: 'Opportunity Detail | Research Decode',
        resolve: {
          academic: academicResolver
        }
      },
      {
        path: 'verify-certificate/:verificationCode',
        loadComponent: () => import('./pages/academic-certificate/academic-certificate.component').then(m => m.AcademicCertificateComponent),
        title: 'Academic Certificate | Research Decode'
      },
      {
        path: 'esupervisors',
        loadComponent: () => import('./pages/esupervisors/esupervisors.component').then(m => m.EsupervisorsComponent),
        title: 'eSupervisors | Research Decode'
      },
      {
        path: 'esupervisors/:username',
        loadComponent: () => import('./pages/esupervisor-detail/esupervisor-detail.component').then(m => m.EsupervisorDetailComponent),
        resolve: {
          esupervisor: esupervisorResolver
        }
      },
      {
        path: 'payment-success',
        loadComponent: () => import('./pages/payment-success/payment-success.component').then(m => m.PaymentSuccessComponent)
      },
      {
        path: 'terms-conditions',
        title: 'Terms and Conditions | Research Decode',
        loadComponent: () => import('./pages/terms-conditions/terms-conditions.component').then(m => m.TermsConditionsComponent)
      },
      {
        path: 'payment-policy',
        title: 'Payment Policy | Research Decode',
        loadComponent: () => import('./pages/payment-policy/payment-policy.component').then(m => m.PaymentPolicyComponent)
      },
      {
        path: 'faq',
        title: 'FAQ | Research Decode',
        loadComponent: () => import('./pages/faq/faq.component').then(m => m.FaqComponent)
      },
      {
        path: 'privacy-policy',
        title: 'Privacy Policy | Research Decode',
        loadComponent: () => import('./pages/privacy-policy/privacy-policy.component').then(m => m.PrivacyPolicyComponent)
      },
      {
        path: 'contact-us',
        title: 'Contact Us | Research Decode',
        loadComponent: () => import('./pages/contact-us/contact-us.component').then(m => m.ContactUsComponent)
      },

      { path: 'user-type-selection', loadComponent: () => import('./pages/user-type-selection/user-type-selection.component').then(m => m.UserTypeSelectionComponent) },

    ],
    runGuardsAndResolvers: 'always'
  },
  {
    path: 'dashboard',
    loadChildren: () => import('./dashboard/dashboard.module').then(m => m.DashboardModule),
    canActivate: [AuthGuard],
    data: { userType: 'expert' }
  },
  {
    path: 'user-dashboard',
    loadChildren: () => import('./user-dashboard/user-dashboard.routes').then(m => m.userDashboardRoutes),
    canActivate: [AuthGuard],
    data: { userType: 'user' }
  },
  {
    path: '',
    loadChildren: () => import('./auth/auth.module').then(m => m.AuthModule)
  },

  // Redirections
  { path: 'auth/login', redirectTo: '/login', pathMatch: 'full' },
  { path: 'auth/signup', redirectTo: '/signup', pathMatch: 'full' },
  { path: 'auth/reset-password', loadComponent: () => import('./pages/redirecting/redirecting.component').then(m => m.RedirectingComponent), canActivate: [PasswordResetRedirectGuard] },
  { path: 'auth/forgot-password', redirectTo: '/forgot-password', pathMatch: 'full' },
  { path: 'research', redirectTo: '/requests', pathMatch: 'full' },
  { path: 'consultancy', redirectTo: '/consultancies', pathMatch: 'full' },
  { path: 'esupervisor', redirectTo: '/consultancies', pathMatch: 'full' },


  {
    path: '404',
    loadComponent: () => import('./components/common/not-found/not-found.component').then(m => m.NotFoundComponent),
    title: '404 - Page Not Found | Research Decode'
  },
  {
    path: 'not-found',
    loadComponent: () => import('./components/common/not-found/not-found.component').then(m => m.NotFoundComponent),
    title: '404 - Page Not Found | Research Decode'
  },
  {
    path: 'test-dev',
    component: TestDevComponent,
    title: 'Test Dev | Research Decode'
  },

  { path: '**', loadComponent: () => import('./components/common/not-found/not-found.component').then(m => m.NotFoundComponent) }
];
